import React from "react";
import { Metrics } from "../assets/svg";
const SideBar = (props) => {
  return (
    <div className="sidebar">
      <div className="sidebar-title">
        <p>KYUPID</p>
      </div>
      <div className="sidebar-content">
        <div className="sidebar-content-header">
          <Metrics />
          <p className="sidebar-content-header-title">Metrics</p>
        </div>
        <div className="sidebar-content-metrics">{props.Metrics}</div>
      </div>
    </div>
  );
};

export default SideBar;
